import ApplicationController from './application_controller'
export default class extends ApplicationController {
	static targets = ["cardContainer"];
	connect () {
		this.moveImages()
	}
	traverseAndTrim(node, remainingLength) {
		//- node.children is undefined for text nodes.
		//- text nodes are not shown in a nodes node.children, only in node.childNodes.
		if(! node.children) {
			let text = node.textContent;
			if(text.length >= remainingLength) {
				node.textContent = node.textContent.slice(0, remainingLength) + "…"
				remainingLength = -1
			} else {
				remainingLength = remainingLength - text.length
			}
		} else {
			for(let c of Array.from(node.childNodes)) {
				if(c.children && c.classList.contains('d-inline-block')){
					continue
				} else if(remainingLength <= 0){
					c.remove()
				} else {
					remainingLength = this.traverseAndTrim(c, remainingLength)
				}
			}
		}
		return remainingLength
	}
	async moveImages(){
		let proms = []
		for(let im of Array.from(this.element.querySelectorAll('img'))){
			proms.push(
				new Promise((resolve) => {
					im.onload = resolve
					if(im.complete){resolve()}
				})
			)
		}
		for(let p of proms){ await p }
		let cc = this.cardContainerTarget
		let textLength = 125;
		let img = cc.qs(".post_card_img");
		let sideBySide = cc.qs(".sideBySide");
		let content = cc.qs(".post_card_text_short")
		let title = cc.qs(".post-header-row")
		if(! content){
			content = cc.qs(".post_card_text_tiny")
			textLength = 100
		}
		if (img && sideBySide){
			let ratio = (img.naturalHeight / img.naturalWidth)
			if(ratio < 1.1){
				sideBySide.classList.add("sideBySideSyke")
				this.traverseAndTrim(content, textLength);
				title.classList.remove("hasSideImage")
			}
		}
	}
}